/* rd-howmany v1.0 (2026-09-30 MJ-AI A线) — RD 壁灯「How many?」:卡片/房间胶囊 ↔ 主题原数量框 #Quantity-<section> 双向同步,
   加购按钮文字随数量变(Add pair to cart — 合计);变体切换(product-information.js 派发 input[name=id] change)后按新单价重算。
   价格格式取自服务端 {{ 100000 | money }} 样本(跟随当前市场货币),不自己猜币种。幂等:同一节点只初始化一次;商品整段替换后自动重挂。 */
(function () {
  if (window.__rdHowmany) { window.__rdHowmany.scan(); return; }
  var MAXQ = 50;
  function fmtFactory(sample) {
    // sample = money(1000.00):如 "$1,000.00" / "€1.000,00" / "1 000,00 €" / "¥1,000"
    var m = String(sample || '').match(/^(.*?)(\d[\d\s.,'  ]*\d)(.*)$/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var pre = m[1], num = m[2], suf = m[3];
    var dec = '', dp = 0, tsep = '';
    var tail = num.match(/([^\d])(\d+)$/);
    if (tail && tail[2].length === 2) { dec = tail[1]; dp = 2; num = num.slice(0, -3); }
    var sep = num.match(/^1([^\d])000$/); if (sep) tsep = sep[1];
    return function (cents) {
      var neg = cents < 0; cents = Math.abs(Math.round(cents));
      var whole = Math.floor(cents / 100), frac = String(cents % 100).padStart(2, '0');
      var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, tsep);
      return (neg ? '-' : '') + pre + w + (dp ? dec + frac : '') + suf;
    };
  }
  // 变体名里的「N 头」(各语种译名:heads / têtes / Köpfe / cabezales / koppen / cabeças / головы·плафоны / رؤوس)
  var HEADS = /(\d+)\s*(?:heads?|t[êe]tes?|k[oö]pfe?|cabezal(?:es)?|cabezas?|kop(?:pen)?|cabe[çc]as?|голов\S*|плафон\S*|рожк\S*|رؤوس|رأس)/i;
  function headsOf(title) { var m = String(title || '').match(HEADS); return m ? +m[1] : 1; }
  function init(root) {
    if (root.__rdhm) return; root.__rdhm = 1;
    var sec = root.getAttribute('data-section');
    var qtyInput = document.getElementById('Quantity-' + sec);
    var form = document.getElementById('product-form-' + sec) || (qtyInput && qtyInput.form) || document.querySelector('form[data-type="add-to-cart-form"]');
    var dataEl = root.querySelector('[data-rdhm-data]');
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { variants: [] }; }
    var byId = {}; (data.variants || []).forEach(function (v) { byId[String(v.id)] = v; });
    var multiHead = (data.variants || []).some(function (v) { return headsOf(v.t) > 1; });
    var fmt = fmtFactory(root.getAttribute('data-money-sample'));
    var T = { atc1: root.getAttribute('data-atc1'), atc2: root.getAttribute('data-atc2'), atcn: root.getAttribute('data-atcn'), each: root.getAttribute('data-each'), from: root.getAttribute('data-from'), notePair: root.getAttribute('data-note-pair'), noteMulti: root.getAttribute('data-note-multi') };
    var cards = [].slice.call(root.querySelectorAll('[data-card]'));
    var rooms = [].slice.call(root.querySelectorAll('[data-room]'));
    var tipBox = root.querySelector('[data-tip-box]'), tipText = root.querySelector('[data-tip-text]'), tipArt = root.querySelector('[data-tip-art]');
    var artTpl = root.querySelector('template[data-rdhm-art]');
    var note = root.querySelector('[data-note]'), trade = root.querySelector('[data-trade]');
    var st = { q: 1, room: null, vid: null };
    function variant() {
      var idIn = form && form.querySelector('input[name="id"]');
      var id = idIn && idIn.value; if (!id || !byId[id]) id = (new URLSearchParams(location.search)).get('variant');
      var v = byId[String(id)] || (data.variants || [])[0] || { p: 0, t: '', a: true };
      st.vid = v.id; return v;
    }
    function maxQ() { var mx = qtyInput && parseInt(qtyInput.getAttribute('max'), 10); return mx > 0 ? Math.min(mx, MAXQ) : MAXQ; }
    function readQty() { var q = qtyInput ? parseInt(qtyInput.value, 10) : st.q; return q > 0 ? q : 1; }
    function syncStepper(q) {   // 主题 quantity-input 只在点 −/+ 时更新按钮可用态 → 我们改了数量要自己同步
      var qi = qtyInput && qtyInput.closest('quantity-input'); if (!qi) return;
      var minus = qi.querySelector('.qtyminus'), plus = qi.querySelector('.qtyplus'), mx = parseInt(qtyInput.getAttribute('max'), 10);
      if (minus) { if (q <= 1) minus.setAttribute('disabled', 'true'); else minus.removeAttribute('disabled'); }
      if (plus) { if (mx > 0 && q >= mx) plus.setAttribute('disabled', 'true'); else plus.removeAttribute('disabled'); }
    }
    function writeQty(q) {
      st.q = q;
      if (qtyInput && String(qtyInput.value) !== String(q)) { qtyInput.value = q; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
      syncStepper(q);
    }
    function atcLabel(v) {
      var q = st.q, u = v.p;
      var t = q === 1 ? T.atc1 : q === 2 ? T.atc2 : T.atcn.replace('__N__', q);
      return q === 1 ? t : t + ' — ' + fmt(u * q);
    }
    var painting = false;
    function paintAtc() {
      if (!form) return;
      var v = variant();
      [].forEach.call(form.querySelectorAll('[data-add-to-cart-text]'), function (el) {
        var btn = el.closest('button'); if (btn && btn.disabled) return;
        var want = atcLabel(v);
        if (el.textContent.trim() !== want) { painting = true; el.textContent = want; painting = false; }
      });
    }
    function paint() {
      var v = variant(), u = v.p, q = st.q, mx = maxQ();
      cards.forEach(function (c) {
        var n = +c.getAttribute('data-card');
        var on = n === 4 ? q >= 4 : q === n;
        c.setAttribute('aria-checked', String(on)); c.tabIndex = on ? 0 : -1;
        var dis = n > mx; c.setAttribute('aria-disabled', String(dis));
        var shown = n === 4 ? Math.max(q, 4) : n;
        var tot = c.querySelector('[data-tot]'); if (tot) { if (n === 4 && !on) { var fp = String(T.from || '__P__').split('__P__'); tot.textContent = ''; var pre = document.createElement('span'); pre.className = 'rdhm__from'; pre.textContent = (fp[0] || '').trim(); tot.appendChild(pre); tot.appendChild(document.createTextNode(fmt(u * 4))); var post = (fp[1] || '').trim(); if (post) { var ps = document.createElement('span'); ps.className = 'rdhm__from rdhm__from--post'; ps.textContent = post; tot.appendChild(ps); } } else { tot.textContent = fmt(u * shown); } } /* v1.1: from 拆成小字标签 */
        var each = c.querySelector('[data-each-out]'); if (each) each.textContent = n > 1 ? T.each.replace('__P__', fmt(u)) : '';
        var so = c.querySelector('[data-step-out]'); if (so) so.textContent = shown;
      });
      rooms.forEach(function (r) { r.setAttribute('aria-pressed', String(r.getAttribute('data-room') === st.room)); });
      if (st.room) {
        var rb = root.querySelector('[data-room="' + st.room + '"]');
        tipText.textContent = rb ? rb.getAttribute('data-tip') : '';
        var art = artTpl && artTpl.content.querySelector('[data-art="' + st.room + '"]');
        tipArt.innerHTML = art ? art.innerHTML : '';
        tipBox.hidden = false;
      } else tipBox.hidden = true;
      if (multiHead) { note.textContent = headsOf(v.t) > 1 ? T.noteMulti : T.notePair; note.hidden = false; } else note.hidden = true;
      trade.hidden = q < 5;
      paintAtc();
    }
    function setQ(q, room) {
      q = Math.max(1, Math.min(maxQ(), q)); st.room = room || null; writeQty(q); paint();
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'rd_howmany', rd_qty: q, rd_room: st.room || '', rd_variant: st.vid }); } catch (e) {}
    }
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-step]');
      if (s) { e.stopPropagation(); setQ(Math.max(4, st.q + (+s.getAttribute('data-step'))), null); return; }
      var r = e.target.closest('[data-room]');
      if (r) { var k = r.getAttribute('data-room'); if (st.room === k) { st.room = null; paint(); } else setQ(+r.getAttribute('data-q'), k); return; }
      var c = e.target.closest('[data-card]');
      if (c && c.getAttribute('aria-disabled') !== 'true') { var n = +c.getAttribute('data-card'); setQ(n === 4 ? Math.max(4, st.q) : n, null); }
    });
    root.addEventListener('keydown', function (e) {
      var c = e.target.closest('[data-card]'); if (!c) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); return; }
      var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!dir) return; e.preventDefault();
      if (document.documentElement.dir === 'rtl' && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) dir = -dir;
      var n = Math.max(1, Math.min(4, +c.getAttribute('data-card') + dir));
      setQ(n === 4 ? Math.max(4, st.q) : n, null);
      var nc = root.querySelector('[data-card="' + n + '"]'); if (nc) nc.focus();
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { var q = readQty(); syncStepper(q); if (q !== st.q) { st.q = q; st.room = null; paint(); } });
      qtyInput.addEventListener('input', function () { var q = readQty(); if (q !== st.q) { st.q = q; paint(); } });
    }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setTimeout(paint, 30); });
      var mo = new MutationObserver(function () { if (!painting) setTimeout(paintAtc, 0); });
      [].forEach.call(form.querySelectorAll('[data-add-to-cart-text]'), function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    }
    document.addEventListener('variantChange', function () { setTimeout(paint, 60); });
    st.q = readQty(); paint();
  }
  function scan() { [].forEach.call(document.querySelectorAll('[data-rd-howmany]'), init); }
  window.__rdHowmany = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var main = document.querySelector('main') || document.body;
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(main, { childList: true, subtree: true });
})();
